import { createContext, useContext } from 'react';
import { FrontendConfig } from '../utils/frontendConfig';

export const FrontendConfigContext = createContext(new FrontendConfig());

export const useFrontendConfig = () => useContext(FrontendConfigContext).get();
